export const LOGIN_USER = 'LOGIN_USER';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_COMPLETED = 'USER_LOGOUT_COMPLETED';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const SET_USER_AUNTHENTICATED = 'SET_USER_AUNTHENTICATED';
export const CHECK_AUTH = 'CHECK_AUTH';
export const REDIRECT_TO_PROFILE = 'REDIRECT_TO_PROFILE';